export default "__VITE_ASSET__5bee6902__"